import {
  ResetPaswordFormData,
  ResetPaswordRequestFormData,
} from '@pages/ResetPassword/ResetPassword.types';
import {
  reqLowerRegex,
  reqUpperRegex,
  reqNumbersRegex,
  specialCharsRegex,
  passwordRegex,
} from '@utils/validation/consts';
import * as yup from 'yup';

yup.setLocale({
  mixed: {
    required: ({ path }) => `resetPassword.errors.${path}.required`,
  },
});

export const resetPasswordRequestFormSchema = yup
  .object<Record<keyof ResetPaswordRequestFormData, yup.AnySchema>>({
    email: yup.string().email('resetPassword.errors.email.format').required(),
  })
  .required();

export const resetPasswordFormSchema = yup
  .object<Record<keyof ResetPaswordFormData, yup.AnySchema>>({
    password: yup
      .string()
      .required('profile.errors.newPassword.required')
      .test({
        name: 'password_validation',
        test: (value, { createError }) => {
          if (!value) return false;

          const errors = [];
          if (!reqLowerRegex.test(value)) errors.push('lowercase');
          if (!reqUpperRegex.test(value)) errors.push('uppercase');
          if (!reqNumbersRegex.test(value)) errors.push('digits');
          if (!specialCharsRegex.test(value)) errors.push('specialChars');
          if (value.length < 8) errors.push('length');

          return errors.length
            ? createError({
                message: errors.join('.'),
                path: 'password',
              })
            : true;
        },
      })
      .matches(passwordRegex, 'profile.errors.newPassword.invalidCharacters'),
    confirmPassword: yup
      .string()
      .when('password', {
        is: (val: string) => (val && val.length > 0 ? true : false),
        then: yup
          .string()
          .oneOf(
            [yup.ref('password')],
            'profile.errors.confirmPassword.different'
          ),
      })
      .required('profile.errors.confirmPassword.required'),
  })
  .required();
